import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import type { CmsApiPage } from '#/modules/cms/api/types/CmsApiPage';
import { getContentUrlByLocale } from '#/modules/cms/helpers/getContentUrlByLocale';

type Props = {
  content: CmsApiPage;
};

export function getPostSearchPageLayoutHandleProps({
  content,
}: Props): LayoutHandleProps {
  const urlByLocale = getContentUrlByLocale({ content });

  return {
    urlByLocale,
    darkBackground: true,
    showDesktopSearch: true,
  };
}
